import { Provider as JotaiProvider } from "jotai";
import { Suspense, StrictMode, useCallback } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

import { LoadingSpinner } from "./shared/components/loading-spinner/loading-spinner.component";

const SWEEPSTAKE_LANDER_URL = "currentSweepLanderUrl";

export function WidgetWrapper({ children }: { children?: React.ReactNode }) {
  const handleReset = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <StrictMode>
      <Suspense fallback={LoadingSpinner}>
        <ErrorBoundary onReset={handleReset} FallbackComponent={WidgetError}>
          <JotaiProvider>{children}</JotaiProvider>
        </ErrorBoundary>
      </Suspense>
    </StrictMode>
  );
}

function WidgetError({ error, resetErrorBoundary }: FallbackProps) {
  console.error(error);
  return (
    <div>
      <h1>Something went wrong</h1>
      <p data-testid="widget-error-message">Please re-enter to start playing!</p>
      <p>
        <a
          className="btn"
          href={
            sessionStorage.getItem(SWEEPSTAKE_LANDER_URL) ||
            "https://www.findkeep.love/collections/all"
          }
          onClick={resetErrorBoundary}
        >
          Continue
        </a>
      </p>
    </div>
  );
}
